import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { SpinnerModule } from '@spartacus/storefront'
import { SharedModule } from '../../../../shared/shared.module'
import { DispenserEndCustomerComponent } from './dispenser-end-customer.component'

@NgModule({
  declarations: [DispenserEndCustomerComponent],
  imports: [CommonModule, SharedModule, SpinnerModule, FormsModule],
  exports: [DispenserEndCustomerComponent]
})
export class DispenserEndCustomerModule {}
